<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->

<div>
  <fab-loading-spinner color="primary" [hidden]="!showSpinner"></fab-loading-spinner>
</div>
<div id="segment-report-container">
  <div id="header-container">
    <div>
      <h1 id="header-text">Manage Propulsion Segments</h1>
    </div>
    <div class="header-buttons">
      <app-upload-button class="upload" [apiUrl]="excelService.excelSheetUrl"
                         (eventEmitter)="upload($event)"></app-upload-button>
      <app-export-button id="export-button" class="no-custom-text"
                         [excelExportService]="excelService"
                         [worksheetExportRequest]="worksheetExportRequest">
        Export
      </app-export-button>
    </div>
  </div>
  <!--Segment Report Table-->
  <div class="gfs-table">

    <ag-grid-angular
      style="height: 100%; width:100%;"
      class="ag-theme-quartz"
      [rowData]="segmentReportData"
      [columnDefs]="segmentReportColumns"
      [autoSizeStrategy]="autoSizeStrategy"
    />
  </div>
</div>
